<template>
  <b-navbar
    type="light"
    class="navbar-light theme-nav fixed-top"
    toggleable="lg"
    fixed="top"
    v-b-scrollspy:nav-scroller
  >
    <div class="container">
      <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
      <b-navbar-brand class="navbar-brand" href="/"
        ><img
          src='../assets/images/logoh.png'
          alt="logo clean touch protect"
          class="mylogo-h"
      /></b-navbar-brand>
      <b-collapse class="default-nav" is-nav id="nav_collapse">
        <b-navbar-nav class="navbar-nav ml-auto" id="mymenu">
          <b-nav-item href="/">Accueil</b-nav-item>
          <b-nav-item href="/#about">À propos</b-nav-item>
          <b-nav-item href="/#feature">Informations</b-nav-item>
          <b-nav-item href="/#screenshot">Applications</b-nav-item>
          <b-nav-item href="/#products">Nos Produits</b-nav-item>
          <b-nav-item href="/#contact">Nous contacter</b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </div>
  </b-navbar>
</template>

<script>
export default {
  name: "Navbar",
};
</script>
<style scoped>
@media screen and (max-width: 767px) {
  .mylogo-h {
    height: 80px;
  }
}
@media screen and (min-width: 768px) {
  .mylogo-h {
    height: 116px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/navbar.vue